var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7673_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8435 0H8.86041L13.1099 4.4334V13.0465C13.1099 14.1247 12.2346 15 11.1564 15H3.8435C2.76528 15 1.89001 14.1247 1.89001 13.0465V1.95349C1.89001 0.875262 2.76528 0 3.8435 0Z",
    fill: "#00733B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85413 0V4.39534H13.1099L8.85413 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19446 11.0042H7.186V11.759H5.19446V11.0042ZM7.80757 7.14795H9.80546V7.89636H7.80757V7.14795ZM5.19446 7.14795H7.186V7.89636H5.19446V7.14795ZM7.80757 8.41644H9.80546V9.1712H7.80757V8.41644ZM5.19446 8.41644H7.186V9.1712H5.19446V8.41644ZM7.80757 9.73568H9.80546V10.4904H7.80757V9.73568ZM5.19446 9.73568H7.186V10.4904H5.19446V9.73568ZM7.80757 11.0042H9.80546V11.759H7.80757V11.0042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7673_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.3b015beb73d1b6b18b5462ba87fc3b59.svg";
export { ForwardRef as ReactComponent };